var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend"},_vm._l((_vm.labels),function(label,i){return _c('div',{key:i,class:['row', { hidden: _vm.hidden[i] }, { clickable: _vm.filterable }],on:{"click":function($event){return _vm.click(i)}}},[_c('div',{style:('background: ' + _vm.colors[i] + ';')}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }